const rsvi_logo = 'https://drive.google.com/uc?id=1bGIg5ESNyCPTO6njXnFBnok6Tjt7SJPE';

export { rsvi_logo };